import React, { useState, useContext, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom"; // Added useLocation
import {
  HeroContact,
  ContactInformation,
  JoinUs,
  ContactForm,
  ContactForm2,
} from "../../Component";
import styles from "./ContactUs.module.css";
import {
  LanguageProvider,
  AboutusPageProvider,
  ContactUsContextProvider,
  ContactUs2ContextProvider,
  ContactUs3ContextProvider,
  ContactUs2Context,
} from "../../store";
import { LanguageContext } from "../../Component/LanguageContext/LanguageContext";
import { Loader } from "../../utilities";
import { useScrollToElementWithDelay } from "../../hooks";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUS = () => {
  useScrollToElementWithDelay("formhere", 1000);
  const [isLoading, setIsLoading] = useState(true);
  const { direction } = useContext(LanguageContext);
  const location = useLocation(); // Add location tracking

  // Show loader on initial load and route changes
  useEffect(() => {
    setIsLoading(true); // Set loading to true on route change
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [location.pathname]); // Dependency on route changes

  return (
    <>
      {isLoading && (
        <div className={styles.loaderWrapper}>
          <span className={styles.loader}></span>
        </div>
      )}
      <LanguageProvider>
        <AboutusPageProvider>
          <ContactUsContextProvider>
            <div className={styles.container}>
              <HeroContact />
              <div id="formhere" className={styles.formcontainer}>
                <Routes>
                  {" "}
                  {/* Wrap the routes inside Routes component */}
                  {/* Define routes for different sections */}
                  <Route path="" element={<ContactInformation />} />
                  <Route
                    path="form"
                    element={
                      <ContactUs2ContextProvider>
                        <ContactForm />
                      </ContactUs2ContextProvider>
                    }
                  />
                  <Route
                    path="form2"
                    element={
                      <ContactUs3ContextProvider>
                        <ContactForm2 />
                      </ContactUs3ContextProvider>
                    }
                  />
                  <Route path="*" element={<ContactInformation />} />
                </Routes>
              </div>
              <div className={styles.bottombg}></div>
            </div>
          </ContactUsContextProvider>
        </AboutusPageProvider>
      </LanguageProvider>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={direction === "rtl"}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        style={{
          marginTop: "80px",
          zIndex: 9999,
        }}
        toastStyle={{
          background: "black",
          color: "rgb(57, 255, 251)",
          marginTop: "15px",
          minHeight: "64px",
        }}
        progressStyle={{
          background: "rgb(57, 255, 251)",
        }}
      />
    </>
  );
};

export default ContactUS;
